import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=36054e0e&scoped=true&"
import script from "./sort.vue?vue&type=script&lang=js&"
export * from "./sort.vue?vue&type=script&lang=js&"
import style0 from "./sort.vue?vue&type=style&index=0&id=36054e0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36054e0e",
  null
  
)

export default component.exports